module.exports = __webpack_public_path__ + "static/3-8f55995774d6b185b0acc54e1dfd6cb4.jpg";